import ApiCrud from "./api-crud";
import apiCaller from "./api-caller";

class TransaccionService extends ApiCrud {
  resource = "transacciones";
  primaryKey = "idtransaccion";

  exportarCSV(params) {
    return apiCaller
      .get(`/${this.resource}/exportar-csv`, { params })
      .then((response) => response.data);
  }
}

export default new TransaccionService();
